import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'logout',
        loadComponent: () => import('./auth/logout/logout.component').then(m => m.LogoutComponent),
      },
      {
        path: 'org',
        loadChildren: () => import('./org/org.module').then(m => m.OrgModule),
      },
      {
        path: 'superadmin',
        loadChildren: () => import('./superadmin/superadmin.module').then(m => m.SuperadminModule),
      },
      {
        path: 'partner',
        loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule),
      },
      {
        path: 'customer-portal',
        loadChildren: () => import('./customer-portal/customer-portal.module').then(m => m.CustomerPortalModule),
      },
      {
        path: 'signup',
        loadComponent: () => import('./auth/signup/signup.component').then(m => m.SignupComponent),
      },
      {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'invitation',
        loadComponent: () => import('./auth/invitation/invitation.component').then(m => m.InvitationComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./auth/change-password/change-password.component').then(m => m.ChangePasswordComponent),
      },
      {
        path: 'org/setup',
        loadComponent: () => import('./org/onboarding/onboarding.component').then(m => m.OnboardingComponent),
        children: [
          {
            path: '',
            redirectTo: 'personal-details',
            pathMatch: 'full',
          },
          {
            path: 'personal-details',
            loadComponent: () => import('./org/onboarding/personal-details/personal-details.component').then(m => m.PersonalDetailsComponent),
          },
          {
            path: 'company-details',
            loadComponent: () => import('./org/onboarding/company-details/company-details.component').then(m => m.CompanyDetailsComponent),
          },
          {
            path: 'invite-users',
            loadComponent: () => import('./org/onboarding/invite-users/invite-users.component').then(m => m.InviteUsersComponent),
          },
        ],
      },
      {
        path: 'form-embed/:id',
        loadComponent: () => import('./org/leads/web-forms/iframe-form/iframe-form.component').then(m => m.IframeFormComponent),
      },
      {
        path: 'form/:id',
        loadComponent: () => import('./org/leads/web-forms/form-view/form-view.component').then(m => m.FormViewComponent),
      },
      {
        path: 'form/:id/thankyou',
        loadComponent: () => import('./org/leads/web-forms/thank-you/thank-you.component').then(m => m.ThankYouComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
